import CommonClient from "./commonClient";
import Helpers from "../../commons/helpers";
import { Constants } from "../../constants/constants";
import { IAddress, ICountries } from "../../commons/interfaces";

interface ICreateEditAddress {
    id?: string,
    tenantCode?: string,
    organizationId?: string,
    addressLine?: string,
    addressLine2?: string,
    ward?: string,
    wardName?: string,
    district?: string,
    districtName?: string,
    city?: string,
    cityName?: string,
    province?: string,
    provinceName?: string,
    country?: string,
    postalCode?: string,
    longitude?: string,
    lattitude?: string,
}

const AddressService = {

    async getCountries(data: {
        type?: number,
        name?: string,
        parentDivision?: string,
    }): Promise<ICountries[]> {
        const newdata = Helpers.handleFormatParams(data);
        const query = Helpers.isNullOrEmpty(newdata) ? "" : `?${newdata}`;

        const result = await CommonClient().get(`${Constants.ApiPath.COMMON.GET_COUNTRIES}${query}`);
        return result.data.result;
    },

    async getChildren(id: string) {
        const result = await CommonClient().get(`${Constants.ApiPath.COMMON.GET_CHILDREN}/${id}`);
        return result.data.result;
    },

    async getAddressByIds(data: { ids?: string[] }): Promise<IAddress[]> {
        const newdata = Helpers.handleFormatParams(data);
        const query = ([...data.ids || []].length === 0) ? "" : `?${newdata}`;

        const result = await CommonClient().get(`${Constants.ApiPath.COMMON.GET_ADDRESS_BY_IDS}${query}`);
        return result.data.result;
    },

    async createAddress(data: ICreateEditAddress) {
        const result = await CommonClient().post(Constants.ApiPath.COMMON.CREATE_ADDRESS, data);
        return result.data;
    },

    async updateAddress(data: ICreateEditAddress) {
        const result = await CommonClient().post(Constants.ApiPath.COMMON.UPDATE_ADDRESS, data);
        return result.data;
    },
}

export default AddressService